__turbopack_context__.v({
  "darkBackground": "InfoTooltip-module__fX3dGq__darkBackground",
  "enablePointerEvents": "InfoTooltip-module__fX3dGq__enablePointerEvents",
  "hover": "InfoTooltip-module__fX3dGq__hover",
  "popover": "InfoTooltip-module__fX3dGq__popover",
  "tooltipBox": "InfoTooltip-module__fX3dGq__tooltipBox",
});
